import {
  ColumnLayout,
  Container,
  SpaceBetween,
  Input,
  FormField,
  TextContent,
} from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";
import { Link } from "react-router-dom";
import { IndividualHandlingConfirmationResponse } from "../../features/api-interfaces";
import { getDivisionLabel } from "../default-constants";
import { useCodelistHook } from "../../app/useCodelistHook";

interface IExaminationInfo {
  data: IndividualHandlingConfirmationResponse;
  isIndividualHandlingTarget: boolean;
}

/**
 * 申請情報
 */
const ApplicationInfo = (props: IExaminationInfo) => {
  const { data, isIndividualHandlingTarget } = props;
  const {
    applicationNo,
    applicationDate,
    corporateNumber,
    companyName,
    industry,
    repName,
    tradeName,
    applicantUserTypeCode,
    applicantEmail,
  } = data;
  const { companyType } = useCodelistHook();

  return (
    <ColumnLayout columns={2}>
      <Container>
        <SpaceBetween direction={"vertical"} size={"s"}>
          <ColumnLayout columns={4}>
            <TextContent>
              <h5>{LABELS.APPLICATION_NO}</h5>
            </TextContent>
            <FormField constraintText="">
              <Link
                to={{
                  pathname: `/application-status/${applicationNo}`,
                }}
              >
                {applicationNo}
              </Link>
            </FormField>
            <TextContent>
              <h5>{LABELS.APPLICATION_DATE}</h5>
            </TextContent>
            <FormField>
              <Input value={applicationDate} readOnly />
            </FormField>
          </ColumnLayout>
          <ColumnLayout columns={4}>
            <TextContent>
              <h5>{LABELS.COMPANY_NAME}</h5>
            </TextContent>
            <FormField>
              <Input value={companyName} readOnly />
            </FormField>
            <TextContent>
              <h5>{LABELS.CORPORATE_NUMBER}</h5>
            </TextContent>
            <FormField>
              {isIndividualHandlingTarget ? (
                <Link
                  to={{
                    pathname: `/individual-counseling-project/${data.individualCounselingTargetNo}`,
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {corporateNumber}
                </Link>
              ) : (
                <Input value={corporateNumber} readOnly />
              )}
            </FormField>
          </ColumnLayout>
          <ColumnLayout columns={4}>
            <TextContent>
              <h5>{LABELS.INDUSTRY}</h5>
            </TextContent>
            <FormField>
              <Input value={industry} readOnly />
            </FormField>
            <TextContent>
              <h5>{LABELS.REP_NAME}</h5>
            </TextContent>
            <FormField>
              <Input value={repName} readOnly />
            </FormField>
          </ColumnLayout>
          <ColumnLayout columns={4}>
            <TextContent>
              <h5>{LABELS.MERCHANT_NAME}</h5>
            </TextContent>
            <FormField>
              <Input value={tradeName} readOnly />
            </FormField>
          </ColumnLayout>
          <ColumnLayout columns={4}>
            <TextContent>
              <h5>{LABELS.APPLICANT_USER_TYPE}</h5>
            </TextContent>
            <FormField>
              <Input
                value={getDivisionLabel(companyType, applicantUserTypeCode)}
                readOnly
              />
            </FormField>
            <TextContent>
              <h5>{LABELS.APPLICANT_EMAIL}</h5>
            </TextContent>
            <FormField>
              <Input value={applicantEmail} readOnly />
            </FormField>
          </ColumnLayout>
        </SpaceBetween>
      </Container>
    </ColumnLayout>
  );
};

export default ApplicationInfo;
